<template>
  <a-modal
    v-model="show"
    :centered="false"
    :keyboard="false"
    :footer="null"
    :width="1100"
    :bodyStyle="bodyStyle"
    :dialog-style="{ top: '65px' }"
    @cancel="handleCancleClick"
    title="告警记录"
  >
    <a-tabs :a="activeKey" @change="callback">
      <a-tab-pane tab="工商系统式" key="0"></a-tab-pane>
      <a-tab-pane tab="工商独立式" key="2"></a-tab-pane>
      <a-tab-pane tab="家用" key="1"></a-tab-pane>
      <a-tab-pane tab="设备" key="4"></a-tab-pane>
    </a-tabs>
    <!-- 表格区域 -->
    <a-table
      ref="TableInfo"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      :rowKey="record => record.id || record.key"
      :scroll="{ x: 500, y: 500 }"
      :row-selection="rowSelection"
      @change="handleTableChange"
    >
      <template slot="operation" slot-scope="text, record">
        <a-icon
          v-if="hasPermission('clearRecord')"
          type="control"
          theme="twoTone"
          @click="onCheck(record)"
          title="操作"
        ></a-icon>
        <a-badge
          v-if="!hasPermission('clearRecord')"
          status="warning"
          text="无权限"
        ></a-badge>
      </template>
    </a-table>
    <a-button
      v-if="hasPermission('clearRecord')"
      :disabled="!selectedRowKeys.length"
      type="primary"
      @click="onClear"
      >清除记录</a-button
    >

    <edit-record-modal
      :visible="recordModalVisible"
      :checkData="checkData"
      @onEditHide="onEditHide"
      @onEditOk="onEditOk"
    />

    <password-validation-modal
      :visible="passwordModalVisible"
      :checkNum="checkNum"
      @onPasswordHide="onPasswordHide"
      @onPasswordOk="onPasswordOk"
    />
  </a-modal>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};
import monitorType from "../business/monitor/monitorType";
import editRecordModal from "../../components/modals/editrecordmodal";
import passwordValidationModal from "../../components/modals/passwordvalidationmodal";
const industryPermission = {
  clearRecord: "alarmRecordIndustry:clearRecord",
};
const dvcRecord = {
  clearRecord: "dvcRecord:clear",
};
export default {
  name: "AlarmRecord",
  components: { editRecordModal, passwordValidationModal },
  data() {
    return {
      formItemLayout,
      recordModalVisible: false,
      passwordModalVisible: false,
      checkNum: 1,
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      loading: false,
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        defaultCurrent: 1,
        defaultPageSize: 10,
        // showQuickJumper: true,
        // showSizeChanger: true,
        showTotal: (total, range) =>
          `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`,
      },
      dataSource: [],
      activeKey: "0",
      bodyStyle: {
        "padding-top": 0,
        "margin-top": "-10px",
      },
      clearReason: "",
      clearId: "",
      checkData: {},
    };
  },
  props: {
    alarmRecordVisiable: {
      require: true,
      default: false,
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
    show: {
      get: function () {
        return this.alarmRecordVisiable;
      },
      set: function () {},
    },
    columns() {
      let dvcColumns = [
        {
          title: "序列号",
          dataIndex: "serialNumber",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "区域名称",
          dataIndex: "areaName",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "设备类型",
          dataIndex: "dvcType",
          customRender: (text) => {
            const arr = monitorType.deviceType.filter(
              (item) => item.id == text
            );
            return arr && arr.length ? arr[0].name : "--";
          },
        },
        {
          title: "告警类型",
          dataIndex: "eventType",
          customRender: (text) => {
            const arr = monitorType.dvcEvent.filter(
              (item) => item.value == text
            );
            return arr && arr.length ? arr[0].name : "--";
          },
        },
        {
          title: "告警时间",
          dataIndex: "createTime",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "结束时间",
          dataIndex: "modifyTime",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: 120,
          fixed: "right",
          scopedSlots: { customRender: "operation" },
        },
      ];

      let columns = [
        {
          title: "区域名称",
          key: "areaName",
          dataIndex: "areaName",
        },
        {
          title: "IMEI码",
          key: "imei",
          dataIndex: "imei",
        },
        {
          title: "设备类型",
          key: "alarmTypeName",
          dataIndex: "alarmTypeName",
        },
        {
          title: "探测器编号",
          key: "detectorNumber",
          dataIndex: "detectorNumber",
        },
        {
          title: "告警类型",
          key: "alarmEventType",
          dataIndex: "alarmEventType",
          customRender: (text, record) => {
            let arr =
              this.activeKey == 0
                ? monitorType.commerceEvent
                : this.activeKey == 1
                ? monitorType.householdEvent
                : monitorType.commerceRestaurantEvent;
            let index = arr.findIndex((item) => {
              return item.value == text;
            });
            return index > -1 ? `${arr[index].name}` : "";
          },
        },
        /*  {
          title: "气体浓度",
          key: "concentration",
          dataIndex: "concentration"
        }, */
        {
          title: "告警时间",
          key: "createTime",
          dataIndex: "createTime",
        },
        {
          title: "结束时间",
          key: "modifyTime",
          dataIndex: "modifyTime",
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ];
      if (this.activeKey != 0) {
        columns.splice(3, 1);
      }
      return this.activeKey == 4 ? dvcColumns : columns;
    },
    eventTypeList() {
      return this.activeKey == 1
        ? monitorType.householdAlarmType
        : monitorType.commerceAlarmType;
    },
  },
  watch: {
    alarmRecordVisiable() {
      if (this.alarmRecordVisiable) {
        this.getData();
      }
    },
  },
  methods: {
    // 判断是否有权限
    hasPermission(btnName) {
      return this.handlePermission(btnName);
    },

    handlePermission(btnName) {
      let permissions = this.$store.state.account.permissions;
      let activeKey = this.activeKey;
      if (activeKey == 4) {
        return permissions.includes(dvcRecord[btnName]);
      } else {
        return permissions.includes(industryPermission[btnName]);
      }
    },
    handleApi(activeKey = this.activeKey) {
      let getAlarmRecordApi = "alarm-record-hosehold";
      let clearAlarmRecordApi = "alarm-record-hosehold/clearAlarmRecordList";
      if (activeKey == 0) {
        getAlarmRecordApi = "alarm-record-industry";
        clearAlarmRecordApi = "alarm-record-industry/clearAlarmRecordList";
      } else if (activeKey == 2) {
        getAlarmRecordApi = "alarm-record-restaurant";
        clearAlarmRecordApi = "alarm-record-restaurant/clearAlarmRecordList";
      } else if (activeKey == 4) {
        getAlarmRecordApi = "dvc-record";
        clearAlarmRecordApi = "dvc-record/clearDvcRecordList";
      }
      return {
        getAlarmRecordApi,
        clearAlarmRecordApi,
      };
    },
    onSelectChange(selectedRowKeys) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.checkNum = selectedRowKeys.length;
    },
    callback(key) {
      this.activeKey = key;
      this.selectedRowKeys = [];
      if (this.paginationInfo) {
        this.paginationInfo.current = 1;
      }
      this.getData();
    },
    handleTableChange(pagination, filters, sorter) {
      // 将这三个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination;
      this.filteredInfo = filters;
      this.sortedInfo = sorter;

      this.getData({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    getData(params = {}) {
      this.loading = true;
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current;
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize;
        params.pageSize = this.paginationInfo.pageSize;
        params.pageNum = this.paginationInfo.current;
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize;
        params.pageNum = this.pagination.defaultCurrent;
      }
      let searchApi = this.handleApi().getAlarmRecordApi;
      this.$get(searchApi, {
        ...params,
        isClear: false,
      })
        .then((res) => {
          console.log(res);
          this.dataSource = res.data.rows;
          const pagination = { ...this.pagination };
          pagination.total = res.data.total;
          this.pagination = pagination;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCancleClick() {
      this.$emit("close");
    },
    onCheck(record) {
      this.recordModalVisible = true;
      this.clearId = record.id;
      this.selectedRowKeys = [];
      this.checkNum = 1;
      this.checkData = record;
    },
    onEditHide() {
      this.recordModalVisible = false;
    },
    onEditOk(clearReason) {
      console.log("clearOk", clearReason);
      this.passwordModalVisible = true;
      this.clearReason = clearReason;
    },

    onClear() {
      this.passwordModalVisible = true;
    },
    onPasswordOk(password) {
      let clearIds = [];
      for (let key of this.selectedRowKeys) {
        clearIds.push(this.dataSource[key].id);
      }
      let ids;
      let clearReason;
      if (!this.selectedRowKeys.length) {
        ids = this.clearId;
        clearReason = this.clearReason;
      } else {
        ids = clearIds.join(",");
        clearReason = 1;
      }
      console.log("清除", { ids, password, clearReason });
      let clearRecordApi = this.handleApi().clearAlarmRecordApi;
      this.$post(clearRecordApi, { ids, password, clearReason }).then((res) => {
        this.passwordModalVisible = false;
        this.recordModalVisible = false;
        this.getData();
        this.selectedRowKeys = [];
        console.log(res.data.message);
        if (res.data.row) {
          this.$notification.error({
            message: "系统提示",
            description: res.data.message,
            duration: 4,
          });
        } else {
          this.$notification.success({
            message: "系统提示",
            description: res.data.message,
            duration: 4,
          });
        }
      });
    },
    onPasswordHide() {
      this.passwordModalVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../static/less/Common";
</style>



// WEBPACK FOOTER //
// src/views/common/AlarmRecord.vue